import React from "react";
import "./coquille.scss";

// Partenaires du dispositif, dans l'ordre historique. Les textes alternatifs
// nomment ce que montre chaque logo (celui d'« ESPOAR » est le logo de la Caf).
const PARTENAIRES = [
  { src: "/assets/logo-espoar.png", alt: "Caf de La Réunion" },
  { src: "/assets/logo-pe.png", alt: "France Travail" },
  { src: "/assets/logo-cd.png", alt: "Département de La Réunion" },
  { src: "/assets/logo-arml.jpeg", alt: "Association régionale des Missions Locales" },
  { src: "/assets/logo-ML-nord.jpeg", alt: "Mission Locale Nord" },
  { src: "/assets/logo-ML-sud.png", alt: "Mission Locale Sud" },
  { src: "/assets/logo-ML-est.png", alt: "Mission Locale Est" },
  { src: "/assets/logo-ML-ouest.png", alt: "Mission intercommunale de l'Ouest" },
];

const LIENS = [
  { href: "/docs/informatique-et-libertes.html", libelle: "Informatique et libertés" },
  { href: "/docs/protection-des-donnees-personnelles.html", libelle: "Protection des données personnelles" },
  { href: "/docs/mentions-legales.html", libelle: "Mentions légales" },
];

const Footer = () => (
  <footer className="pied-page">
    <div className="pied-page__interieur">
      <h2 className="pied-page__titre" id="pied-page-partenaires">
        Nos partenaires
      </h2>
      <ul className="pied-page__partenaires" aria-labelledby="pied-page-partenaires">
        {PARTENAIRES.map((p) => (
          <li key={p.src}>
            <img src={p.src} alt={p.alt} loading="lazy" />
          </li>
        ))}
      </ul>
      <ul className="pied-page__liens">
        {LIENS.map((l) => (
          <li key={l.href}>
            <a href={l.href} target="_blank" rel="noopener noreferrer">
              {l.libelle}
              <span className="sr-only"> (nouvelle fenêtre)</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  </footer>
);

export default Footer;
